<app-modal #metadataSelectionModal [modalId]="'metadataSelectionModal'" [modalContentId]="'source-nodelist-drop'"
  [showCloseAlert]="false" [modalSize]="'small'" (closeEvent)="onCancel()">

  <modal-div class="body-content">
    <div class="col-12">
      <h3 id="" class="font-4x font-bold">{{reportName}}</h3>
      <p [innerHtml]="selectedNode?.title ? selectedNode?.title : selectedNode?.full_statement"></p>

      <app-preloader *ngIf="loadingMeatadata" style="left: 0;" [loaderText]="'Loading Data..'"
        class="w-100 position-fixed preloader-backdrop"></app-preloader>

      <div>
        <app-data-table *ngIf="metadataList" #dataTable [showMenu]="false" class="w-100" [columnList]="listOfColumn"
          [dataSet]="metadataList" [showCheckBox]="true" [uniqueField]="'metadata_id'"
          (rowCheckedEvent)="changeSelection($event.data)">
        </app-data-table>

      </div>

    </div>
  </modal-div>

  <modal-div class="footer-buttons">
    <button type="button" class="btn btn-primary btn-sm float-right" id="downloadBtn" (click)="downloadIRM()"
      data-dismiss="modal">Download</button>
  </modal-div>
</app-modal>
